export function zeroPad(num: number, pad: number) {
  return (""+num).padStart(pad, '0')
}

export function currencyFiEur(value: any): string {
  const fixed = Number.isInteger(value) ? 0 : 2
  const str = (value || value == 0) ? (parseFloat(value).toFixed(fixed) + "€") : ''
  return str.replace('.', ',')
}
